import graphql__d626bd2463d60b52bb78 from "./__generated__/ParticipativeModuleResultsFormField_result.graphql.js";
import { graphql, useFragment } from "react-relay";

import ParticipativeModuleResultsFormFieldPie from "./ParticipativeModuleResultsFormFieldPie";
import ParticipativeModuleResultsFormFieldBar from "./ParticipativeModuleResultsFormFieldBar";
import ParticipativeModuleResultsFormFieldStacked from "./ParticipativeModuleResultsFormFieldStacked";
import ParticipativeModuleResultsFormFieldStackedAbsolute from "./ParticipativeModuleResultsFormFieldStackedAbsolute";
import ParticipativeModuleResultsFormFieldMultiBar from "./ParticipativeModuleResultsFormFieldMultiBar";
import ParticipativeModuleResultsFormFieldMap from "./ParticipativeModuleResultsFormFieldMap";
import ParticipativeModuleResultsFormFieldWordCloud from "./ParticipativeModuleResultsFormFieldWordCloud";

const ParticipativeModuleResultsFormFieldTypes = {
  ParticipativeModuleResultsFormFieldPie,
  ParticipativeModuleResultsFormFieldBar,
  ParticipativeModuleResultsFormFieldStacked,
  ParticipativeModuleResultsFormFieldStackedAbsolute,
  ParticipativeModuleResultsFormFieldMultiBar,
  ParticipativeModuleResultsFormFieldMap,
  ParticipativeModuleResultsFormFieldWordCloud
};

const ParticipativeModuleResultsFormField = props => {
  const result = useFragment(ParticipativeModuleResultsFormField_result, props.result);
  const ParticipativeModuleResultsFormFieldType =
    ParticipativeModuleResultsFormFieldTypes[result.__typename];

  return <ParticipativeModuleResultsFormFieldType {...props} result={result} />;
};

const ParticipativeModuleResultsFormField_result = graphql__d626bd2463d60b52bb78;

export default ParticipativeModuleResultsFormField;
